var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(" "+_vm._s(_vm._f("moment")(_vm.dateVal,"Do MMM YYYY"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }